import { create } from 'zustand';

interface BookmarkSelectionStore {
  selectedItems: string[];
  isSelectionActive: boolean;
  clearSelection: () => void;
  isSelected: (item: string) => boolean;
  toggleSelectedItem: (item: string) => void;
  setIsSelectionActive: (isActive: boolean) => void;
}

export const useBookmarkSelectionStore = create<BookmarkSelectionStore>(
  (set, get) => ({
    selectedItems: [],
    isSelectionActive: false,
    clearSelection: () => set({ selectedItems: [] }),
    isSelected: item => get().selectedItems.includes(item),
    toggleSelectedItem: item =>
      set(state => ({
        selectedItems: state.selectedItems.includes(item)
          ? state.selectedItems.filter(id => id !== item)
          : [...state.selectedItems, item],
      })),
    setIsSelectionActive: isActive => set({ isSelectionActive: isActive }),
  })
);
